import React from 'react';
import { MethodList } from './methodList';
import { NeedMethodMessage } from './needMethodMessage';


const TextArea = ({ placeholder, updateValue, initialVal }) => {
  return (
    <input
      type="text"
      class="form-control"
      onChange={(e) => updateValue(e.target.value)}
      defaultValue={initialVal}
      placeholder={placeholder} />
  );
};

const Textfield = ({ placeholder, updateValue, initialVal }) => {
  return (
    <input
      type="text"
      class="form-control"
      onChange={(e) => updateValue(e.target.value)}
      defaultValue={initialVal}
      placeholder={placeholder} />
  );
};

const BooleanSelect = ({ initialVal, updateValue }) => {

  return (
    <div class="mb-5">
      <label class="toggle-switch mx-2" for="customSwitch">
        <input type="checkbox" class="js-toggle-switch toggle-switch-input" disabled id="customSwitch" />
        <span class="toggle-switch-label">
          <span class="toggle-switch-indicator"></span>
        </span>
      </label>
    </div>
  );
};

const Dropdown = ({ dropdownOptions = [], updateValue, disabled, val }) => {

  return (
    <select
      value={val ? val : ''}
      className="my-1 form-select block w-full pl-3 pr-10 py-2 text-base leading-6 border-gray-300 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5"
      onChange={(e) => updateValue(e.target.value)}
      disabled={disabled}
    >
      {dropdownOptions.length !== 1 && (
        <option disabled value="">
          {' '}
          -- select an option --{' '}
        </option>
      )}
      {dropdownOptions.map((option, index) => (
        <option key={`${index}-${option.name}`} value={option.value}>
          {option.name}
        </option>
      ))}
    </select>
  );
};

const Field = ({
  description,
  placeholder,
  type,
  val,
  updateValue,
  dropdownOptions,
  disabled,
}) => {
  let actualField;
  switch (type) {
    case 'dropdown':
      actualField = (
        <Dropdown
          updateValue={updateValue}
          dropdownOptions={dropdownOptions}
          disabled={disabled}
          val={val}
        />
      );
      break;
    case 'textfield':
      actualField = (
        <Textfield
          updateValue={updateValue}
          placeholder={placeholder}
          initialVal={val}
        />
      );
      break;
    case 'boolean':
      actualField = (
        <BooleanSelect updateValue={updateValue} initialVal={val} />
      );
      break;
    default:
      actualField = (
        <TextArea
          updateValue={updateValue}
          placeholder={placeholder}
          initialVal={val}
        />
      );
  }

  return (
    <div>
      <div className="max-w-lg flex rounded-md shadow-sm"></div>

      <p class="h5 text-secondary mt-2 mb-3">{description}</p>
      {actualField}

    </div>
  );
};

const MethodCall = ({
  web3URL,
  args,
  runRequest,
  argumentList,
  onUpdateArguments,
}) => {

  return (
    <div class="card card-bordered mb-3 ">

      <div class="card-header">
        <h5 class="card-title m-1">Method</h5>
      </div>

      <div class="card-body">

        {/* List of supported methods */}

        <MethodList web3URL={web3URL} web3Lib="web3" />

        {/* Method parameters */}

        <h5 class="card-title mt-1 mb-3">Parameters</h5>
        <hr/>

        <NeedMethodMessage argLength={args.length} />

        <div>
          {args.length > 0}
          {args.map((arg, i) => (
            <Field
              {...arg}
              key={i}
              val={argumentList[i]}
              updateValue={(val) => {
                onUpdateArguments(val, i);
              }}
            />
          ))}

          <div class="m-5">
            <button type="button" class="btn btn-sm btn-primary btn-block" onClick={runRequest}>
              <span class="h5 text-white font-weight-bold">Send Request</span>
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};

export { MethodCall };
